module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "ch00_fm03_tit"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('strong', [_vm._v("Keeping Your Child Healthy in a Germ-Filled World")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('strong', [_vm._v("A G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UIDE")]), _vm._v(" "), _c('em', [_vm._v("for")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Athena P. Kourtis, M.D., Ph.D., M.P.H.")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8add654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_tit.vue
// module id = 66
// module chunks = 0